module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-navbar"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Navbar")]), _vm._v(" "), _c('mt-navbar', {
    staticClass: "page-part",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "1"
    }
  }, [_vm._v("选项一")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "2"
    }
  }, [_vm._v("选项二")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "3"
    }
  }, [_vm._v("选项三")])], 1), _vm._v(" "), _c('div', [_c('mt-cell', {
    staticClass: "page-part",
    attrs: {
      "title": "当前选中"
    }
  }, [_vm._v(_vm._s(_vm.selected))])], 1), _vm._v(" "), _c('mt-tab-container', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": "1"
    }
  }, _vm._l((10), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '内容 ' + n
      }
    })
  })), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "2"
    }
  }, _vm._l((4), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '测试 ' + n
      }
    })
  })), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "3"
    }
  }, _vm._l((6), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '选项 ' + n
      }
    })
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff028a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/navbar.vue
// module id = 328
// module chunks = 0